import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "home-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, " Home ", -1 /* HOISTED */)
const _hoisted_5 = { class: "home-header__welcome" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "divider divider--top divider--stretch mb-24" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-24" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h5" }, " My Projects ")
], -1 /* HOISTED */)
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 1,
  class: "project-card__image project-card__image--default"
}
const _hoisted_10 = { class: "project-card__title" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "project-card__alerts" }
const _hoisted_13 = { class: "project-card__notifications-count" }
const _hoisted_14 = {
  key: 1,
  class: "mb-64"
}
const _hoisted_15 = {
  ref: "load_more_my_projects_trigger",
  class: "load-more-trigger"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.loading)
          ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("p", _hoisted_5, " Welcome back, " + _toDisplayString($options.first_name), 1 /* TEXT */)
              ]),
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", {
                class: _normalizeClass(["results-grid", { 'results-grid--loading': $data.loading_my_projects }])
              }, [
                ($data.projects && $data.projects.length)
                  ? (_openBlock(), _createBlock(_TransitionGroup, {
                      key: 0,
                      name: "grid",
                      tag: "ul",
                      class: "grid grid--xs flex flex--wrap relative mb-32"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.projects, (project) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: 'my-project-' + project.id,
                            class: "grid__item a3-12 f6-6 mb-8"
                          }, [
                            _createVNode(_component_router_link, {
                              to: { name: 'projects__project', params: { project_id: project.id } },
                              class: "project-card"
                            }, {
                              default: _withCtx(() => [
                                ($options.getThumbnailOption( project ))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: $options.getThumbnailOption( project ).image_small_url || $options.getThumbnailOption( project ).thumbnail_url,
                                      alt: $options.getThumbnailOption( project ).title,
                                      class: "project-card__image"
                                    }, null, 8 /* PROPS */, _hoisted_8))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_9)),
                                _createElementVNode("h2", _hoisted_10, _toDisplayString(project.title), 1 /* TEXT */),
                                _createElementVNode("button", {
                                  ref_for: true,
                                  ref: `favourite-${project.id}`,
                                  class: _normalizeClass(["project-card__favourite", [
										{ 'project-card__favourite--selected': $options.userHasFavouritedProject( project.id ) },
										{ 'project-card__favourite--toggled': $data.toggled_favourites.includes( project.id ) },
										{ 'project-card__favourite--loading': $data.loading_favourites.includes( project.id ) }
									]]),
                                  onClick: _withModifiers($event => ($options.toggleProjectAsFavourite( project.id )), ["prevent"])
                                }, null, 10 /* CLASS, PROPS */, _hoisted_11),
                                (project.notification_count)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 2,
                                      to: { name: 'projects__project', params: { project_id: project.id }, query: { tab: 'notifications' } },
                                      class: "project-card__notifications"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createElementVNode("span", _hoisted_13, _toDisplayString(project.notification_count), 1 /* TEXT */)
                                        ])
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createElementBlock("p", _hoisted_14, " Not assigned to any projects. ")),
                _withDirectives(_createElementVNode("div", _hoisted_15, null, 512 /* NEED_PATCH */), [
                  [_vShow, $data.total_projects_count > $data.projects.length]
                ])
              ], 2 /* CLASS */)
            ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}